import type { Colours, TextStyles } from '../../types'

export const getBase = ({ colours, textStyles }: Params) => `
  body {
    ${textStyles.body}
    color: ${colours.black100};
    -webkit-print-color-adjust: exact;
  }
`

///////// IMPLEMENTATION /////////

type Params = {
  colours: Colours
  textStyles: TextStyles
}
